import { SectionHeader, Typography } from 'web-library';
import React from 'react';
import { useTOCStyles } from '../../../pages/helpdesk/TermsOfUse';

const GeneralPrivacyStatement = () => {
  const { classes } = useTOCStyles();

  return (
    <div>
      <SectionHeader title="General" />
      <ol type="a">
        <li className={classes.paragraph}>
          <Typography variant="body1">
            This is a Government of Singapore digital service.
          </Typography>
        </li>
        <li className={classes.paragraph}>
          <Typography variant="body1">
            {`We may use "cookies", where a small data file is sent to your browser to ` +
              `store and track  information about you when you enter our digital service. The cookie is used to track  information ` +
              `such as the number of users and their frequency of use, profiles of users and their preferred digital ` +
              `services. While this cookie can tell us when you enter our digital services and which pages you visit, it ` +
              `cannot read data off your hard disk.`}
          </Typography>
        </li>
        <li className={classes.paragraph}>
          <Typography variant="body1">
            {`You can choose to accept or decline cookies. Most web browsers automatically accept ` +
              `cookies, but you can usually modify your browser setting to decline cookies if you prefer. This may ` +
              `prevent you from taking full advantage of the digital service.`}
          </Typography>
        </li>
      </ol>
    </div>
  );
};

export default GeneralPrivacyStatement;
